function qboIntegration(integrations) {
  return integrations === null || integrations === void 0 ? void 0 : integrations.find(i => i.source === 'direct-qbo');
}
export const selectors = {
  qboIntegration
};